import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initMixpanel } from "./lib/mixpanel";
import { initMetaPixel } from "./lib/metaPixel";

// Analítica de producto. Sin `REACT_APP_MIXPANEL_TOKEN` es un no-op, así que la
// web corre igual en local y en cualquier entorno sin token configurado.
// Va antes del primer render para no perder los eventos de la carga inicial.
initMixpanel();
initMetaPixel();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
